/**
 * Paths that mount the same in-progress application under both App route trees
 * (WithoutAuthenticate and Authenticated). Switching trees on login remounts these
 * pages and wipes form state.
 *
 * Note: `/` is CoreForm home and must be an exact match — never a startsWith prefix.
 */
const PRESERVE_ROUTE_TREE_ON_LOGIN_EXACT = [
    '/',
];

const PRESERVE_ROUTE_TREE_ON_LOGIN_PREFIXES = [
    '/get-quote',
    '/core-form',
    '/short-term-production',
    '/short-term-production-insurance',
    '/shorttermproduction-insurance',
    '/shorttermproductions-insurance',
    '/equipment-insurance',
    '/equipmentinsurance',
    '/generalliability',
    '/generalliabilityinsurance',
    '/equipmentgeneralliability',
    '/billing',
];

/**
 * Given a pathname, When the user logs in mid-application, Then App must keep the
 * current route tree mounted if this returns true.
 * @param {string} pathname
 * @returns {boolean}
 */
export function shouldPreserveRouteTreeOnLogin(pathname = '') {
    const path = String(pathname || '').toLowerCase().split('?')[0] || '/';

    if (PRESERVE_ROUTE_TREE_ON_LOGIN_EXACT.includes(path)) {
        return true;
    }

    return PRESERVE_ROUTE_TREE_ON_LOGIN_PREFIXES.some((prefix) => path.startsWith(prefix));
}
